import React from "react";

const OtherTags = ({ data }) => {
  return (
    <div className="OtherTags">
      {/*<Image src={`/api/proxyimage?url=${encodeURIComponent(data?.icon)}`} alt="" width={"20"} height={20} />*/}
      <img src={data?.icon} alt="" width="20" height="20" />
      <span className="OtherTags__text">{data?.text}</span>
    </div>
  );
};

export default React.memo(OtherTags);
